import { useEffect, useState } from "react";
import { api } from "../lib/api";
import Layout from "../components/Layout";
import { Globe2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function SourcingRequests() {
  const [rows, setRows] = useState([]);
  const load = async () => { const {data} = await api.get("/sourcing-requests"); setRows(data); };
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => {
    try { await api.patch(`/sourcing-requests/${id}`, {status}); toast.success(status); load(); }
    catch { toast.error("Failed"); }
  };
  return (
    <Layout>
      <div className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-sky-600 mb-1">Talent Sourcing Requests</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 tracking-tight">Sell the search</h1>
        <p className="text-sm text-slate-500 mt-1">Open searches where an accepted Job Order has legitimate hard requirements that no current ConnectMyHub candidate satisfies.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-100/70 text-slate-600 text-[11px] uppercase tracking-widest font-semibold">
            <tr><th className="text-left px-4 py-3">Role</th><th className="text-left px-4 py-3">Location</th><th className="text-left px-4 py-3">Comp range</th><th className="text-left px-4 py-3">Urgency</th><th className="text-left px-4 py-3">Sourced</th><th className="text-left px-4 py-3">Status</th><th className="text-right px-4 py-3">Actions</th></tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} data-testid={`sr-row-${r.id}`} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-semibold text-slate-900">{r.role} <span className="text-[10px] text-slate-500 ml-1">{r.seniority}</span></td>
                <td className="px-4 py-3 text-slate-700"><Globe2 size={11} className="inline mr-1 text-slate-500"/>{r.required_country || r.location_type}</td>
                <td className="px-4 py-3 font-mono text-xs">${r.compensation_min}-${r.compensation_max}</td>
                <td className="px-4 py-3"><span className="text-[10px] font-semibold px-2 py-0.5 border border-amber-200 bg-amber-50 text-amber-800 rounded">{r.urgency}</span></td>
                <td className="px-4 py-3 font-mono">{r.candidates_sourced}</td>
                <td className="px-4 py-3"><span className="text-[10px] font-semibold px-2 py-0.5 border border-slate-200 rounded">{r.status}</span></td>
                <td className="px-4 py-3 text-right">
                  <div className="flex gap-1 justify-end">
                    <button data-testid={`sr-progress-${r.id}`} onClick={()=>setStatus(r.id, "In Progress")} className="text-[10px] px-2 py-0.5 border border-sky-300 text-sky-700 rounded font-semibold">Progress</button>
                    <button data-testid={`sr-close-${r.id}`} onClick={()=>setStatus(r.id, "Closed")} className="text-[10px] px-2 py-0.5 border border-slate-300 rounded font-semibold">Close</button>
                  </div>
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="text-center py-12 text-sm text-slate-500 flex flex-col items-center gap-2"><AlertTriangle size={18} className="text-slate-400"/>No open sourcing requests.</td></tr>}
          </tbody>
        </table>
      </div>
    </Layout>
  );
}
